import React from 'react'
import { Link } from 'react-scroll'

import Section from './Section'
import PortfolioItem from './PortfolioItem'
import Gallery from './Gallery'
import ButtonLink from './ButtonLink'
import SocialMediaButton from './SocialMediaButton'
import VisibleObserver from './utility/VisibleObserver'
import Phone from './Phone'
import { CenteredContent } from './standard'

import { isMobile, isDesktop } from '../lib/responsive'

const styles = {
  root: {
    width: '100%',
    maxWidth: 850
  },
  gallery: {
    pointerEvents: 'none'
  }
}

const getPhoneStyles = ({ tilt, isFocusedItem }) => ({
  transition: 'transform 100ms linear',
  left: isDesktop() && (tilt === 'left') && 40,
  right: isDesktop() && (tilt === 'right') && 40,
  transform: (isFocusedItem || isMobile()) ?
    'none' :
    (tilt === 'left' ? 'rotate(-6deg)' : 'rotate(6deg)')
})

const PortfolioItemPhone = ({ id, images, tilt, isFocusedItem }) => {
  return (
    <Link to={id} spy={true} style={{ cursor: isFocusedItem ? 'initial' : 'pointer' }} smooth={true} offset={50} duration={500}>
      <Phone style={{ ...styles.phone, ...getPhoneStyles({ tilt, isFocusedItem }) }} >
        <Gallery
          images={images}
          auto={isFocusedItem}
          userInteractable={isFocusedItem}
          style={styles.gallery}
        />
      </Phone>
    </Link>
  )
}

const Site = () =>
  <CenteredContent>
    <div style={styles.root}>
      <Section style={{
        height: isDesktop() ? 300 : 250
      }}
      innerStyle={{
        borderTop: 'none',
        textAlign: 'center',
        padding: '0 30px'
      }}>
        <CenteredContent>
          <h1>Matt Vague</h1>
          <p style={{ fontSize: 18, opacity: 0.5, fontWeight: 500 }}>
            Designer + Developer + Student in Montreal, Canada.
          </p>
        </CenteredContent>
      </Section>
      <VisibleObserver>
        { ({ bounds, inView }) =>
          <PortfolioItem
            id='artona'
            expanded={bounds.top < 200}
            image={
              <PortfolioItemPhone
                images={[
                  './images/artona_1.png',
                  './images/artona_2.png',
                  './images/artona_3.png',
                  './images/artona_4.png',
                  './images/artona_5.png'
                ]}
                id='artona'
                tilt='left'
                isFocusedItem={bounds.top < 200}
              />
            }
            align='right'
            style={{ position: 'relative', zIndex: 0 }}
          >
            <h2 style={{ color: '#9a8c8c' }}>Artona E-Commerce</h2>
            <h3 style={{ color: '#9a8c8c' }}>Mobile Web App</h3>
            <p>
              Artona is the leading graduation photography studio in the province of British Columbia.
              In collaboration with <a href='http://nano3labs.com/'>Nano3Labs</a>, Matt led development
              of a new mobile e-commerce experience using React and Redux.
            </p>
          </PortfolioItem>
        }
      </VisibleObserver>
      <VisibleObserver>
        { ({ bounds, inView }) =>
          <PortfolioItem
            id='my-foresome'
            expanded={bounds.top < 200}
            image={
              <PortfolioItemPhone
                images={[
                  './images/my_foresome_1.png',
                  './images/my_foresome_2.png',
                  './images/my_foresome_3.png',
                  './images/my_foresome_4.png'
                ]}
                id='my-foresome'
                tilt='right'
                isFocusedItem={bounds.top < 200}
              />
            }
            align='left'
            style={{ position: 'relative', zIndex: 0 }}
          >
            <h2 style={{ color: '#55d651' }}>MyForesome</h2>
            <h3 style={{ color: '#55d651' }}>iOS App + API</h3>
            <p>
              MyForesome is an app for groups of golfers to easily coordinate their next round.
              Matt was hired to develop a Swift iOS app, as well as a backend Ruby on Rails API.
            </p>
          </PortfolioItem>
        }
      </VisibleObserver>
      <VisibleObserver>
        { ({ bounds, inView }) =>
          <PortfolioItem
            id='watch-it'
            expanded={bounds.top < 150}
            image={
              <PortfolioItemPhone
                images={[
                  './images/watch_it_1.png',
                  './images/watch_it_2.png',
                  './images/watch_it_3.png',
                  './images/watch_it_4.png'
                ]}
                id='watch-it'
                tilt='left'
                isFocusedItem={bounds.top < 150}
              />
            }
            align='right'
            style={{ position: 'relative', zIndex: 1 }}
          >
            <h2 style={{ color: '#23aef3' }}>Watch It</h2>
            <h3 style={{ color: '#23aef3' }}>iOS App + API</h3>
            <p>
              Watch It is an app to lets sports fans wa. Matt was hired to develop an Objective-C iOS app, as well as a
              backend Ruby on Rails API.
            </p>
          </PortfolioItem>
        }
      </VisibleObserver>
      <PortfolioItem
        id='postcards'
        image={
          <Link to="postcards" style={{ cursor: 'pointer' }} spy={true} smooth={true} offset={50} duration={500}>
            <img
              src='./images/postcards.png'
              width='400'
              height='240'
              style={{ padding: 20 }}
            />
          </Link>
        }
        expanded={true}
        align='left'
        stickyDescription={false}
        style={{ position: 'relative', zIndex: 2 }}
      >
        <h2 style={{ color: '#f5af2f' }}>Postcards From the Plane</h2>
        <h3 style={{ color: '#f5af2f' }}>In-Flight App + API</h3>
        <p>
          Postcards From the Plane allows passengers to design and send a physical postcard anywhere
          in the world right from their seat. Matt was hired to develop a postcard composition pipeline,
          as well as backend reporting tools.
        </p>
      </PortfolioItem>
      <Section innerStyle={{ padding: isDesktop () ? '70px 100px' : '70px 40px' }}>
        <blockquote>
          "Matt maintained our ground server for several years and we were very happy with his work. He has the rare combination of being an excellent communicator, as well as a talented software engineer. Matt was sensitive to our situation as a start-up and always found the quickest and smartest route to a solution. He’s also a pleasure to work with and worked well collaborating with our other team members. We highly recommend him."
          <span>
            - Sarah Fitzmaurice, Director, Flight Level Media
          </span>
        </blockquote>
      </Section>
      <Section className='about-me' innerStyle={{ padding: isDesktop () ? '70px 80px' : '70px 40px' }}>
        <h2 style={{ color: '#8162b1' }}>A bit about Matt</h2>
        <p>
          Matt is a software developer living in Montreal, Canada. Weaving together a range of creative and technical talents, he builds applications that are more than just useful, but enjoyable and memorable.
        </p>
        <p>
          In his near-decade of industry experience, he's had the good fortune to help improve online banking at VersaPay and Simple, make it easier for teams to collaborate using Flow App, work on client projects at MetaLab, and help Canadians gain better access to healthcare at Medeo and New Hippo.
        </p>
        <p>
          Matt's current stack of choice for delivering high-quality user-facing software is React / Redux in the browser, Ruby on Rails on the server, and Swift on iOS, but he is open to whatever choice of technology will deliver the best result for a given project.
        </p>
      </Section>
      <Section innerStyle={{ textAlign: 'center', padding: 0, marginBottom: 60 }}>
        <ButtonLink
          href='mailto:mattvague@gmail.com'
          style={{ position: 'relative', top: -23 }}
        >
          Get in touch
        </ButtonLink>
      </Section>
      <Section innerStyle={{ textAlign: 'center', border: 'none' }}>
        <SocialMediaButton href="http://twitter.com/mattvague">&#xe287;</SocialMediaButton>
        <SocialMediaButton href="http://dribbble.com/mattvague">&#xe221;</SocialMediaButton>
        <SocialMediaButton href="http://github.com/mattvague">&#xe236;</SocialMediaButton>
        <SocialMediaButton href="https://www.linkedin.com/in/matt-vague-849b0281/">&#xe252;</SocialMediaButton>
      </Section>
    </div>
  </CenteredContent>

export default Site



// WEBPACK FOOTER //
// ./src/components/Site.js